var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-10 pb-7 justify-between items-center",
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              attrs: {
                placeholder: "Search by name",
                isIcon: _vm.yes,
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                debounceTime: 500,
              },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = $$v
                },
                expression: "name",
              },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }